import { getTestIds } from 'seagull/utils/TestIds';
export const GetCadenceDaysDropdownTID = (parentTestId)=>getTestIds(parentTestId);
